import {SubAPI} from "./SubAPI";

export type VoiceClip = {
    id: number;
    createdBy: number;
    file: number;
    content: string | null;
    projectChangeset: number | null;
    projectNote: number | null;
    archived: boolean;
}

// VoiceClipInfo is the lightweight shape embedded in list responses
// (e.g. on each project note).
export type VoiceClipInfo = {
    id: number;
    file: number;
    hasTranscript: boolean;
}

export class VoiceClips extends SubAPI {
    list(props: { projectChangeset?: number; projectNote?: number }) {
        return this.fetcher.get<VoiceClip[]>("/api/voice-clips", props);
    }

    transcript(props: { id: number }) {
        return this.fetcher.get<string>("/api/voice-clip/transcript", props);
    }

    upload(props: {
        file: Blob;
        projectChangeset?: number;
        projectNote?: number;
    }) {
        return this.fetcher.postFormData<VoiceClip>("/api/voice-clip/upload", {
            file: props.file,
            projectChangeset: props.projectChangeset ? props.projectChangeset.toString() : "",
            projectNote: props.projectNote ? props.projectNote.toString() : "",
        });
    }
}
